export default __webpack_public_path__ + "static/img1-21137903a719526280f256db744f8359.jpg";